export const list = {
  table: {
    name: '水洗機部品名',
    manufacture: 'メーカー名',
    supplier: '発注先',
    price: '価格/円',
    inventory: '在庫数',
  },
  pageHeader: {
    title: '部品リスト　TOP',
    new: '新規',
  },
}
